import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import {LogDataAPI} from "./../../API/Caller/LogAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";


const Logs = () =>{

    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);

    //const userPerPage = 2;
    //const numberOfUsersVisited = page * userPerPage;
    //const totalPages = Math.ceil(users.length / userPerPage);


    useEffect(() => {

        LogDataAPI(setLogs, setLoading);

        //console.log('>>>>'+usersList);

    }, []);

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Activity Logs</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        <Link to="faq.html" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Refresh">
                                                <i className="ti ti-refresh-dot"></i>
                                        </Link>
                                        <Link to="#" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Collapse" id="collapse-header">
                                                <i className="ti ti-chevrons-up"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">

                            

                            <div className="card-body">

                                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                                    <div className="dropdown">
                                        
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        
                                    </div>
                                </div>

                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                												
                                                <th>Login On</th>
                                                <th>Name</th>
                                                <th>IP</th>
                                                <th>Browser</th>
                                                <th>Message</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="6">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (logs && logs.length > 0  ? 
                                                ( logs.map(log => 
                                                    (
                                            
                                                        <tr key={log.id}>
                                                            <td>{moment(log.login_time).format('DD-MM-YYYY h:mm:ss')}</td>
                                                            <td>{log.user_id}</td>
                                                            <td>{log.ip}</td>
                                                            <td>{log.browser}</td>
                                                            <td>{log.message}</td>
                                                            <td className="text-end">
                                                                <Link to="" class="btn btn-dark btn-sm">
                                                                    <i className="ti ti-pencil"></i> Edit
                                                                </Link>
                                                                <button type="button" class="btn btn-danger btn-sm">
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>													
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="6">
                                                        <center><p>No record found...</p></center>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                <div className="row align-items-center">
                                    {/*<div className="col-md-6">
                                        <div className="datatable-length"></div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="datatable-paginate"></div>
                                    </div>*/}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

    </div>
    )
}

export default Logs;